import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ComponentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: max-content;
  justify-content: space-between;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 22px;
  align-items: center;
`;
